import { Command } from 'commander';
import { clearBinding, readBinding } from '../database-binding.js';

export const unbindCommand = new Command('unbind')
  .description('Clear the database binding for this worktree')
  .action(async () => {
    const previous = readBinding();
    if (!previous) {
      console.log('No worktree binding to clear.');
      return;
    }
    // ENOENT between read and unlink is fine — the binding is already gone.
    clearBinding();
    console.log(`Worktree unbound (was: ${previous}).`);
  });
